export function formatCount(target: number, progress: number, suffix = ''): string {
  const clamped = Math.min(Math.max(progress, 0), 1)
  const eased = 1 - Math.pow(1 - clamped, 3)
  return `${Math.round(target * eased)}${suffix}`
}
